import recommendedItemQueries from '@apis/queries/recommendedItemQueries';
import { useQuery } from '@tanstack/react-query';

/**
 * 현재 상품을 제외하고 다른 추천 상품 로딩 훅
 * @param shopId
 * @param itemId
 */
function useShopRecommendedItems(shopId: string, itemId: string) {
    const { data } = useQuery(recommendedItemQueries.shop(shopId));
    const title = data?.title;
    const items = data?.items
        .filter((item) => item.shopItemId !== itemId);
    return { title, items };
}

export default useShopRecommendedItems;
